(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7666],{

/***/ 49771:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detailPackage.m",
      function () {
        return __webpack_require__(28626);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8745);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var TaggingGTM = function(props) {
    var ref;
    // 아래는 Google tag manager 관련
    var eventPriceFetch = (0,_QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(props.query.evCd);
    var eventPrice = (ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!eventPrice) return;
        try {
            dataLayer.push({
                event: "addToCart",
                ecommerce: {
                    currencyCode: "KRW",
                    add: {
                        products: [
                            {
                                name: "".concat(props.eventDetail.evNm),
                                id: "".concat(props.goodsDetail.goodsCd),
                                price: "".concat(Number(eventPrice.adtPrice + eventPrice.bafAdtCost + eventPrice.airTaxAdtCost)),
                                category: "".concat(props.query.menu)
                            }, 
                        ]
                    }
                }
            });
        } catch (e) {
            ;
        }
    }, [
        eventPrice
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (TaggingGTM);


/***/ }),

/***/ 72326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);




var key = "useRcmnOfSimList";
/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/ var getPath = function() {
    return "/bff/chorus/braze/rcmnOfSimList";
};
/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/ var useRcmnOfSimList = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(),
                method: "POST",
                data: {
                    evCd: evCd
                }
            }).then(function(r) {
                var ref;
                // TYPE_0 은 현재 상품과 동일, 그래서 제외
                var filteredList = ((ref = r.data.crmRcmnSearchSimResultList) !== null && ref !== void 0 ? ref : []).filter(function(v) {
                    return v.type !== "TYPE_0";
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, r.data), {
                    crmRcmnSearchSimResultList: filteredList
                });
            });
        },
        staleTime: 1000 * 30 * 60,
        throwOnError: true
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useRcmnOfSimList);



/***/ }),

/***/ 70189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 쿠폰 리스트 조회 by user
 *   `/pkg/coupon/by-event/${evCd}/${webCustNo}`
 * parameter
 *   `evCd` 예약자 일련번호
 *   `webCustNo` 회원 일련번호
 * ```*/ var key = "useCouponByUser";
var getPath = function(evCd, webCustNo) {
    if (!evCd || !webCustNo) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/coupon/by-event/").concat(evCd, "/").concat(webCustNo);
};
var useCouponByUser = function(evCd, webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd, webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd, webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 0,
        gcTime: 0
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCouponByUser);



/***/ }),

/***/ 69230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ eventAvailabilityAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);






/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useCode";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/availability");
};
/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventAvailabilityAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(evCd) {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = getPath(evCd), _tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function eventAvailabilityAsync(evCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventAvailability = function(evCd, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useEventAvailability)));



/***/ }),

/***/ 13028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useEventPromotion";
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/pkg/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/promotion");
};
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/pkg/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventPromotion = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventPromotion);



/***/ }),

/***/ 28626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ detailPackage_m_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./components/layout/footer/Mobile/index.tsx + 1 modules
var Mobile = __webpack_require__(37875);
// EXTERNAL MODULE: ./components/layout/header/Mobile/index.tsx + 3 modules
var header_Mobile = __webpack_require__(62499);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/common/GTMTags.tsx
var GTMTags = __webpack_require__(9946);
// EXTERNAL MODULE: ./hooks/common/useCountdown.tsx
var useCountdown = __webpack_require__(71392);
// EXTERNAL MODULE: ./components/style/detailpackage/itineraryM.tsx
var itineraryM = __webpack_require__(50341);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsLive.ts
var useGlobalGoodsLive = __webpack_require__(28906);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerGoodsDeal.ts
var useBannerGoodsDeal = __webpack_require__(82767);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./public/M/images/content/event/yellowpick/banner_yellowpick_571.png
var banner_yellowpick_571 = __webpack_require__(33954);
var banner_yellowpick_571_default = /*#__PURE__*/__webpack_require__.n(banner_yellowpick_571);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useGoodsBannerPick.ts
var useGoodsBannerPick = __webpack_require__(38307);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailBanner/index.tsx
/* eslint-disable react/jsx-no-target-blank */ 

















var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var BannerContents = function(param) {
    var contents = param.contents;
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl", {
        selectDiv: "MiddtlBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: contents.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: contents.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* EventBanner */.cK, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                        target: (0,commonUtil/* getTarget */.U9)(item.mTarget),
                        href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL).concat(item.mLink),
                        onClick: function() {
                            return taggingClick(item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.mImgPath),
                            alt: item.mAlt
                        })
                    })
                }, index);
            })
        })
    });
};
var BannerYellowPangDeal = function(param) {
    var deal = param.deal;
    var PangdealText = function() {
        var targetDate = dayjs_min_default()(deal.dealEdTm).add(1, "minute");
        var countdown = (0,useCountdown/* default */.Z)(targetDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* PriceBox */.bz, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* PangdealProduct */.pb, {
                            children: deal.dealType === "T" ? "타임특가" : "선착순특가"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* PangdealDate */.Q0, {
                            children: deal.dealType === "T" ? countdown !== null && countdown !== void 0 ? countdown : "종료" : "상품 ".concat(deal.dealRervCnt || 0, "개")
                        }),
                        "\xa0",
                        countdown !== null && " 남음"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "".concat(deal.dealRervCnt > 0 || countdown !== null ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(deal.price - deal.dealGoodsPrice), "원 즉시할인가격") : "")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: deal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
            href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/promotion/yellowPangDeal.yb"),
            target: "_self",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* PangdealPrice */.G_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PangdealText, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* PangdealLink */.rV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "전체보기"
                    })
                })
            ]
        })
    });
};
var BannerYellowLive = function(param) {
    var live = param.live;
    dayjs_min_default().extend((isBetween_default())); // isBetween 사용
    var dspYn = live.dspYn, liveDt = live.liveDt, liveTime = live.liveTime;
    // 방송 노출 조건 Y가 아닌 경우 - 노출 X
    if (dspYn !== "Y") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var liveStartDate = dayjs_min_default()(liveDt);
    var liveEndDate = liveStartDate.add(Number(liveTime), "minute");
    var today = dayjs_min_default()();
    var LiveText = function() {
        if (today.isBefore(liveStartDate)) {
            var countdown = (0,useCountdown/* default */.Z)(liveStartDate);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveDate */.Uq, {
                        children: "COMING SOON"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveState */.kE, {
                        children: countdown
                    })
                ]
            });
        } else if (today.isBetween(liveStartDate, liveEndDate)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveDate */.Uq, {
                        children: "ON AIR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveState */.kE, {
                        children: "실시간 방송 중"
                    })
                ]
            });
        } else {
            var formattedDate = "".concat(liveStartDate.format("MM/DD"), "(").concat(daykor[liveStartDate.day()], ") ").concat(liveStartDate.format("HH:mm"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveDate */.Uq, {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveState */.kE, {
                        children: "방영 완료"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* BannerYellowLive */.$g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
            href: "".concat(config_public/* default.ENV_PORTAL_M_URL */.Z.ENV_PORTAL_M_URL, "/promotion/yellowLive"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* LiveText */.sS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveTit */.TH, {
                            children: "최대 혜택으로 떠나는 생생한 여행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveText, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* LiveLink */.Ge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "바로가기"
                    })
                })
            ]
        })
    });
};
var BannerYellowPick = function(param) {
    var pick = param.pick;
    var link = pick.webBannerLink === "AUTOLINK" ? "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/promotion/promotionDetail.yb?mstNo=").concat(pick.bnrMstNo) : pick.mlink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* EventBanner */.cK, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (banner_yellowpick_571_default()),
                alt: "옐로PICK 혜택 특가로 떠나는 이달의 여행지"
            })
        })
    });
};
var DetailBannerComponent = function(props) {
    var ref, ref1, ref2, ref3;
    var goodsCd = props.goodsDetail.goodsCd;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GOPM"); // WEB_CONT_DIVI_CD 상품상세_요금영역
    var bannerContents = ((ref = bannerContentsFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var bannerDealFetch = (0,useBannerGoodsDeal/* default */.ZP)(goodsCd);
    var bannerDeal = (ref1 = bannerDealFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var bannerLiveFetch = (0,useGlobalGoodsLive/* default */.Z)(goodsCd);
    var bannerLive = (ref2 = bannerLiveFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var bannerPickFetch = (0,useGoodsBannerPick/* default */.ZP)(goodsCd);
    var bannerPick = (ref3 = bannerPickFetch.data) === null || ref3 === void 0 ? void 0 : ref3.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (bannerContents.length > 0 || bannerDeal || bannerLive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* EventBannerWrap */.st, {
            children: [
                bannerContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContents, {
                    contents: bannerContents
                }),
                bannerPick && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPick, {
                    pick: bannerPick
                }),
                bannerDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPangDeal, {
                    deal: bannerDeal
                }),
                bannerLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowLive, {
                    live: bannerLive
                })
            ]
        })
    });
};
var DetailBanner = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailBanner Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailBannerComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailBanner = (/*#__PURE__*/(0,react.memo)(DetailBanner));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/couponUtil.ts
var couponUtil = __webpack_require__(15702);
// EXTERNAL MODULE: ./components/common/modal/alert/Mobile.tsx
var alert_Mobile = __webpack_require__(88515);
// EXTERNAL MODULE: ./framework/ui/mobile/button/index.tsx + 8 modules
var mobile_button = __webpack_require__(28426);
// EXTERNAL MODULE: ./framework/ui/mobile/layout/index.tsx + 2 modules
var layout = __webpack_require__(48418);
// EXTERNAL MODULE: ./framework/ui/mobile/list/BulletListItem.tsx
var BulletListItem = __webpack_require__(93242);
// EXTERNAL MODULE: ./framework/ui/mobile/text/index.ts + 2 modules
var mobile_text = __webpack_require__(6671);
// EXTERNAL MODULE: ./hooks/services/queries/account/useCustomerMe.ts + 1 modules
var useCustomerMe = __webpack_require__(38186);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponByEvent.ts
var useCouponByEvent = __webpack_require__(93381);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponDown.ts
var useCouponDown = __webpack_require__(46894);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailCoupon/index.tsx



























/** 선착순 쿠폰 마감임박 잔여 수량 기준 */ var FCFS_IMMINENT_REMAIN_CNT = 20;
var DetailCouponComponent = function(props) {
    var ref, ref1, ref2;
    var query = props.query;
    var ref3 = (0,useCustomerMe/* default */.ZP)(), loginInfo = ref3.data, isLoginLoading = ref3.isLoading;
    var webCustNo = (loginInfo === null || loginInfo === void 0 ? void 0 : (ref = loginInfo.body) === null || ref === void 0 ? void 0 : ref.nonUser) === false ? loginInfo.body.webCustNo : undefined;
    var CouponByEventFetch = (0,useCouponByEvent/* default */.ZP)(query.evCd, webCustNo, {
        enabled: !isLoginLoading
    });
    var coupon = (ref1 = CouponByEventFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(query.evCd);
    var eventPrice = (ref2 = eventPriceFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var displayCoupons = (0,couponUtil/* getDisplayCouponsByEvent */.N)(coupon, eventPrice === null || eventPrice === void 0 ? void 0 : eventPrice.adtPrice);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref4[0];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref5 = (0,react.useState)(null), tooltipIndex = ref5[0], setTooltipIndex = ref5[1];
    var tooltipRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (tooltipIndex === null) return;
        var handleClickOutside = function(e) {
            if (tooltipRef.current && (0,_instanceof/* default */.Z)(e.target, Node) && !tooltipRef.current.contains(e.target)) {
                setTooltipIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        tooltipIndex
    ]);
    var toggleTooltip = function(index) {
        return setTooltipIndex(tooltipIndex === index ? null : index);
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("goods_down_coupon", {
        evCd: query.evCd,
        selectDiv: "MiddtlButton"
    }).taggingClick;
    var handleCoupon = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(coupon) {
            var couponNo, fcfsYn, remainCnt, body, _tmp, result, data, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        couponNo = coupon.couponNo, fcfsYn = coupon.fcfsYn, remainCnt = coupon.remainCnt;
                        if (fcfsYn === "Y" && Number(remainCnt) <= 0) return [
                            2
                        ];
                        if (!((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.body.nonUser) === false)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        taggingClick(coupon);
                        _tmp = {};
                        body = (_tmp.compId = "1", _tmp.webCustNo = loginInfo.body.webCustNo, _tmp.couponNo = couponNo, _tmp);
                        return [
                            4,
                            (0,useCouponDown/* default */.Z)(body)
                        ];
                    case 2:
                        result = _state.sent();
                        data = result.data;
                        _tmp1 = {};
                        if (data.errorCode === "0000") {
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                    text: data.errorMsg
                                }));
                            });
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useCouponByEvent"
                            ], _tmp1.type = "active", _tmp1));
                        } else if (data.errorCode === "2004") {
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                    text: "이미 쿠폰을 발급받으셨습니다."
                                }));
                            });
                        } else {
                            alert(data.errorMsg);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        alert("오류가 발생하였습니다.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        open(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                alertType: "confirm",
                                text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                                afterConfirm: function() {
                                    return LoginUtil.login();
                                }
                            }));
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCoupon(coupon) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: displayCoupons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Area */.uN, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TitleWrap */.BV, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_text/* SubTitle */.DK, {
                            children: "사용 가능 쿠폰"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* CouponTotalText */.N2, {
                            children: [
                                "총 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: displayCoupons.length
                                }),
                                "건"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponList */.hO, {
                    children: displayCoupons.map(function(item, index) {
                        var isFcfs = item.fcfsYn === "Y";
                        var remainCnt = Number(item.remainCnt);
                        var isSoldOut = isFcfs && remainCnt <= 0;
                        var isImpending = isFcfs && !isSoldOut && remainCnt <= FCFS_IMMINENT_REMAIN_CNT;
                        var couponButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextDefaultButton */.mm, {
                            size: "default",
                            types: "subCtn",
                            text: "쿠폰받기",
                            onClick: function() {
                                return handleCoupon(item);
                            }
                        });
                        if (isSoldOut) {
                            couponButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextDefaultButton */.mm, {
                                size: "default",
                                types: "subCtn",
                                text: "마감",
                                disabled: true
                            });
                        } else if (item.downYn === "N") {
                            couponButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextDefaultButton */.mm, {
                                size: "default",
                                types: "whiteCtn",
                                text: "사용가능"
                            });
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponItem */.hc, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                gap: "10",
                                align: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* CouponContent */.CJ, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* CouponIcon */.zc, {
                                                children: [
                                                    item.discDiviCd === "M" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                        children: [
                                                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.discAmt),
                                                            "원"
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                        children: [
                                                            item.discRate,
                                                            "%"
                                                        ]
                                                    }),
                                                    isFcfs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* CouponTagGroup */.s1, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponTag */.Xt, {
                                                                        type: "limited",
                                                                        children: "선착순사용"
                                                                    }),
                                                                    isImpending && /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponTag */.Xt, {
                                                                        type: "impending",
                                                                        children: "마감임박"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TooltipWrap */.hN, {
                                                                ref: tooltipIndex === index ? tooltipRef : undefined,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* TooltipButton */.p8, {
                                                                        type: "button",
                                                                        onClick: function() {
                                                                            return toggleTooltip(index);
                                                                        }
                                                                    }),
                                                                    tooltipIndex === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* Tooltip */.u, {
                                                                        children: "선착순 사용 가능 수량이 마감될 경우, 쿠폰을 다운로드 하더라도 할인 쿠폰 적용이 불가합니다."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponNameWrap */.Hv, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponTitle */.E9, {
                                                    children: item.couponNm
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* CouponExpired */.Cx, {
                                                children: item.validityDiviCd === "DD" ? "발급일로부터 ".concat(item.validityDday, "일 유효") : "".concat(dayjs_min_default()(item.validityFrDt).format("YYYY.MM.DD"), " ~ \n										").concat(dayjs_min_default()(item.validityToDt).format("YYYY.MM.DD"))
                                            })
                                        ]
                                    }),
                                    couponButton
                                ]
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* BulletBox */.vt, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletListItem/* default */.Z, {
                            children: [
                                "해당 쿠폰은 행사 전용 혜택으로, 회원 등급별 쿠폰을 다운받으시려면\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/memberGrade.yb"),
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: "이곳"
                                }),
                                "을 클릭해주세요."
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var DetailCoupon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailCoupon Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCouponComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailCoupon = (/*#__PURE__*/(0,react.memo)(DetailCoupon));

// EXTERNAL MODULE: ./components/product/pages/detailPackage/mobile/detailHeader/index.tsx + 2 modules
var detailHeader = __webpack_require__(23681);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/mobile/detailPrice/index.tsx + 2 modules
var detailPrice = __webpack_require__(99939);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@yb/styled-px2rem/esm/index.esm.js
var index_esm = __webpack_require__(53842);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionlinkM.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	padding: 0 15px;\n	margin: 30px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 18px;\n	font-weight: bold;\n	color: var(--emp-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	width: 100%;\n	margin-top: 15px;\n	border: 1px solid var(--yellow-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	+ li {\n		border-top: 1px solid var(--yellow-color);\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	padding: 15px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	white-space: nowrap;\n	margin-left: 10px;\n	&::after {\n		display: inline-block;\n		width: 8px;\n		height: 8px;\n		margin-top: 2px;\n		margin-left: 5px;\n		border-top: 1px solid var(--default-color);\n		border-left: 1px solid var(--default-color);\n		transform: rotate(135deg);\n		content: "";\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Wrap = index_esm/* default.div */.ZP.div(_templateObject());
var SubTitle = index_esm/* default.h3 */.ZP.h3(_templateObject1());
var LinkList = index_esm/* default.ul */.ZP.ul(_templateObject2());
var LinkListItem = index_esm/* default.li */.ZP.li(_templateObject3());
var Link = index_esm/* default.a */.ZP.a(_templateObject4());
var LinkTitle = index_esm/* default.p */.ZP.p(_templateObject5(), (0,mobile_text/* Ellipsis */.mH)(1));
var LinkArrow = index_esm/* default.span */.ZP.span(_templateObject6());


// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPromotion.ts
var useEventPromotion = __webpack_require__(13028);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailPromotion/index.tsx










var DetailPromotionComponent = function(props) {
    var ref;
    var query = props.query;
    var useEvtPromotion = (0,useEventPromotion/* default */.ZP)(query.evCd);
    var promotionList = ((ref = useEvtPromotion.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl", {
        selectDiv: "relatedBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: promotionList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Area */.uN, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: "관련 기획전"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkList, {
                        children: promotionList.map(function(param, index) {
                            var mstLink = param.mstLink, mstNm = param.mstNm;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkListItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL).concat(mstLink),
                                    onClick: function(e) {
                                        e.preventDefault();
                                        taggingClick({
                                            link: mstLink,
                                            title: mstNm
                                        });
                                        (0,commonUtil/* onClickSSO */.Zy)(e, "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL).concat(mstLink));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTitle, {
                                            dangerouslySetInnerHTML: {
                                                __html: mstNm.replaceAll(/<br\s*\/?>/gi, "")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkArrow, {})
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
var DetailPromotion = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailPromotion Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPromotionComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailPromotion = (/*#__PURE__*/(0,react.memo)(DetailPromotion));

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionproductM.tsx

function promotionproductM_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	padding: 30px 0;\n"
    ]);
    promotionproductM_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 0 15px;\n	font-size: 18px;\n	color: var(--emp-color);\n	font-weight: bold;\n"
    ]);
    promotionproductM_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	margin-top: 15px;\n	margin-bottom: 38px;\n	.swiper-slide {\n		width: 250px;\n	}\n"
    ]);
    promotionproductM_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	padding: 0 15px;\n\n	.swiper-slide:not(:last-child) {\n		margin-right: 15px;\n	}\n"
    ]);
    promotionproductM_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	overflow: hidden;\n	a {\n		display: block;\n	}\n"
    ]);
    promotionproductM_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	height: 167px;\n	margin-bottom: 11px;\n\n	img {\n		width: 100%;\n		height: 167px;\n		vertical-align: top;\n	}\n"
    ]);
    promotionproductM_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function promotionproductM_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--default-color);\n"
    ]);
    promotionproductM_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-height: 48px;\n	margin-bottom: 8px;\n	font-weight: bold;\n	font-size: 17px;\n	color: var(--emp-color);\n	line-height: 1.41;\n	",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 15px;\n	color: var(--default-color);\n	line-height: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	margin-top: 14px;\n	font-size: 15px;\n	line-height: 1;\n	align-items: flex-end;\n	justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-left: auto;\n	color: var(--red-color);\n\n	strong {\n		font-size: 18px;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var promotionproductM_Wrap = index_esm/* default.div */.ZP.div(promotionproductM_templateObject());
var promotionproductM_SubTitle = index_esm/* default.h3 */.ZP.h3(promotionproductM_templateObject1());
var SliderWrap = index_esm/* default.div */.ZP.div(promotionproductM_templateObject2());
var Slider = (0,index_esm/* default */.ZP)(swiper_react/* Swiper */.tq)(promotionproductM_templateObject3());
var SwiperSlideWrap = (0,index_esm/* default */.ZP)(swiper_react/* SwiperSlide */.o5)(promotionproductM_templateObject4());
var ImageBox = index_esm/* default.div */.ZP.div(promotionproductM_templateObject5());
var InfoBox = index_esm/* default.div */.ZP.div(promotionproductM_templateObject6());
var SlideTitle = index_esm/* default.div */.ZP.div(_templateObject7(), (0,mobile_text/* Ellipsis */.mH)(2));
var promotionproductM_Date = index_esm/* default.div */.ZP.div(_templateObject8());
var InfoBottomBlock = index_esm/* default.div */.ZP.div(_templateObject9());
var Price = index_esm/* default.div */.ZP.div(_templateObject10());


// EXTERNAL MODULE: ./framework/ui/mobile/slide/SlideImage.tsx
var SlideImage = __webpack_require__(77434);
// EXTERNAL MODULE: ./hooks/services/queries/chorus/rcmn/useRcmnOfSimList.ts
var useRcmnOfSimList = __webpack_require__(72326);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailRecommendProduct/index.tsx
/* eslint-disable no-shadow */ 









var DetailRecommendProductComponent = function(props) {
    var evCd = props.query.evCd;
    /** 추천상품 조회 */ var rcmnOfSimListFetch = (0,useRcmnOfSimList/* default */.ZP)(evCd, {
        placeholderData: {
            crmRcmnSearchSimResultList: [],
            errorCode: "",
            errorMsg: ""
        }
    });
    var recommendList = rcmnOfSimListFetch.data.crmRcmnSearchSimResultList || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: recommendList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproductM_Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(promotionproductM_SubTitle, {
                    children: "추천 상품"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWrap, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        slidesPerView: "auto",
                        children: recommendList.slice(0, 10) // 최대 10개만 노출
                        .map(function(recommend, index) {
                            var outStartDt = recommend.outStartDt, adtPrice = recommend.adtPrice, landing = recommend.landing, imageThum1 = recommend.imageThum1, evNm = recommend.evNm;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperSlideWrap, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
                                    href: landing,
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideImage/* default */.Z, {
                                                src: imageThum1,
                                                alt: "프로모션 이미지",
                                                width: 225,
                                                height: 150
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTitle, {
                                                    children: evNm
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproductM_Date, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "출발일"
                                                        }),
                                                        " ",
                                                        dayjs_min_default()(outStartDt).format("YYYY.MM.DD")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBottomBlock, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(adtPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
var DetailRecommendProduct = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailRecommendProduct Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailRecommendProductComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailRecommendProduct = (/*#__PURE__*/(0,react.memo)(DetailRecommendProduct));

// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./public/M/images/ico/ico_spr.png
var ico_spr = __webpack_require__(15042);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./framework/ui/mobile/input/RadioN.tsx
var RadioN = __webpack_require__(34900);
;// CONCATENATED MODULE: ./components/style/detailpackage/couponselectpopupM.tsx

function couponselectpopupM_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 24px 24px 32px;\n"
    ]);
    couponselectpopupM_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 24px;\n	padding-bottom: 24px;\n	border-bottom: 1px solid var(--hr-color);\n"
    ]);
    couponselectpopupM_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-bottom: 8px;\n	font-family: "PT-semibold";\n	font-size: 14px;\n	color: var(--sub-title-color);\n'
    ]);
    couponselectpopupM_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 8px;\n	width: 100%;\n"
    ]);
    couponselectpopupM_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex: 1;\n	gap: 8px;\n	overflow: hidden;\n\n	> div:last-of-type {\n		overflow: visible;\n	}\n"
    ]);
    couponselectpopupM_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					position: relative;\n					width: 100%;\n					height: 56px;\n					padding: 16px;\n					border: 1px solid var(--hr-color);\n					border-radius: 8px;\n					> ",
        " {\n						width: 100%;\n						> label {\n							position: absolute;\n							z-index: 1;\n							inset: 0;\n							display: flex;\n							align-items: center;\n							padding-top: 2px;\n							padding-left: 48px;\n							box-sizing: border-box;\n						}\n					}\n				"
    ]);
    couponselectpopupM_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					",
        " {\n						padding: 16px 16px 14px 16px;\n						border: 1px solid var(--line-color);\n						border-right-color: var(--hr-color);\n						border-radius: 8px;\n					}\n				"
    ]);
    couponselectpopupM_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n\n	> ",
        " {\n		gap: 8px;\n	}\n\n	",
        ";\n"
    ]);
    couponselectpopupM_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	width: 100%;\n	cursor: pointer;\n"
    ]);
    couponselectpopupM_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 30px;\n	height: 30px;\n	background-image: url(",
        ");\n	background-position: -134px -38px;\n	background-size: 300px 300px;\n"
    ]);
    couponselectpopupM_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function couponselectpopupM_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			pointer-events: none;\n\n			> p {\n				background-color: #bdbdbd;\n				color: #fff;\n			}\n		"
    ]);
    couponselectpopupM_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			> ",
        " {\n				display: none;\n			}\n		"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	justify-content: center;\n	gap: 3px;\n	width: 82px;\n	height: 100%;\n	margin-left: -1px;\n	border: 1px solid var(--line-color);\n	border-left-color: var(--hr-color);\n	border-radius: 8px;\n	background-color: #fff;\n\n	> p {\n		border-radius: 8px;\n		background-color: var(--brand-color);\n		font-size: 12px;\n		font-family: "PT-bold";\n		width: 54px;\n		height: 20px;\n		padding: 0 6px;\n		line-height: 20px;\n		box-sizing: border-box;\n		color: #fff;\n		white-space: nowrap;\n	}\n\n	',
        "\n\n	",
        '\n\n	&::before,\n	&::after {\n		position: absolute;\n		display: block;\n		width: 8px;\n		height: 8px;\n		background-color: #fff;\n		content: "";\n	}\n	&::before {\n		top: 8px;\n		left: -4px;\n	}\n	&::after {\n		bottom: 8px;\n		left: -4px;\n	}\n'
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 6px;\n	overflow: hidden;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	margin-top: 12px;\n	padding-left: 10px;\n	font-size: 14px;\n	color: var(--caption-color);\n	line-height: 1.5;\n\n	&::before {\n		position: absolute;\n		top: 8px;\n		left: 0;\n		width: 4px;\n		height: 4px;\n		border-radius: 50%;\n		background: var(--disable-text-color);\n		content: "";\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 6px;\n	flex: 0 0 auto;\n	line-height: normal;\n	color: var(--alert-color);\n	font-family: "PT-bold";\n	font-size: 18px;\n	white-space: nowrap;\n	flex-wrap: wrap;\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 4px;\n	flex-wrap: wrap;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			border-color: var(--alert-color);\n			background-color: var(--alert-color);\n			color: #fff;\n			border-radius: 8px 8px 8px 0;\n		"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			border-color: var(--alert-color);\n			background-color: #ffeceb;\n			color: var(--alert-color);\n		"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	height: 18px;\n	line-height: 18px;\n	padding: 0 8px;\n	border-radius: 8px;\n	border: 1px solid var(--line-color);\n	font-family: "PT-bold";\n	font-size: 11px;\n	white-space: nowrap;\n	color: var(--caption-color);\n	box-sizing: border-box;\n\n	',
        "\n\n	",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	flex: 0 0 auto;\n	line-height: normal;\n	font-family: "PT-semibold";\n	font-size: 14px;\n	color: var(--sub-title-color);\n	display: -webkit-box;\n	-webkit-box-orient: vertical;\n	-webkit-line-clamp: 3;\n	overflow: hidden;\n	white-space: normal;\n	word-break: break-all;\n	text-overflow: ellipsis;\n'
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	justify-content: space-between;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 4px;\n	font-size: 16px;\n	font-family: "PT-bold";\n	color: var(--title-color);\n	line-height: 1.5;\n'
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 20px;\n	height: 20px;\n	background-image: url(",
        ");\n	background-position: -165px -38px;\n	background-size: 300px 300px;\n	background-color: transparent;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-size: 18px;\n	font-family: "PT-medium";\n	color: var(--alert-color);\n	line-height: 1.5;\n\n	> em {\n		font-family: "PT-bold";\n	}\n'
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	left: 50%;\n	transform: translateX(-50%);\n	bottom: 36px;\n	z-index: 1;\n	display: inline-flex;\n	width: 100%;\n	padding: 16px;\n	border-radius: 8px;\n	border: 1px solid var(--border-color);\n	background: var(--disable-bg-color);\n	box-sizing: border-box;\n\n	&::before {\n		position: absolute;\n		bottom: -6px;\n		left: 71px;\n		transform: translateX(-50%) rotate(45deg);\n		width: 11px;\n		height: 11px;\n		background: var(--disable-bg-color);\n		border-right: 1px solid var(--border-color);\n		border-bottom: 1px solid var(--border-color);\n		border-radius: 0 0 2px 0;\n		content: "";\n		z-index: 2;\n	}\n\n	> ul {\n		display: flex;\n		flex-direction: column;\n		gap: 6px;\n\n		li {\n			position: relative;\n			padding-left: 10px;\n			font-size: 14px;\n			font-family: "PT-medium";\n			color: var(--caption-color);\n			line-height: 1.5;\n\n			&::before {\n				position: absolute;\n				top: 8px;\n				left: 0;\n				width: 4px;\n				height: 4px;\n				border-radius: 50%;\n				background: var(--disable-text-color);\n				content: "";\n			}\n		}\n	}\n'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	line-height: 1;\n	padding: 16px;\n	height: 56px;\n	border-radius: 8px;\n	border: 1px solid var(--hr-color);\n	font-size: 14px;\n	color: var(--caption-color);\n	font-family: "PT-medium";\n	box-sizing: border-box;\n'
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



var CouponSelectContent = index_esm/* default.div */.ZP.div(couponselectpopupM_templateObject());
var CouponSection = index_esm/* default.div */.ZP.div(couponselectpopupM_templateObject1());
var CouponSectionTitle = index_esm/* default.p */.ZP.p(couponselectpopupM_templateObject2());
var CouponList = index_esm/* default.ul */.ZP.ul(couponselectpopupM_templateObject3());
var CouponInfo = index_esm/* default.div */.ZP.div(couponselectpopupM_templateObject4());
var CouponListItem = index_esm/* default.li */.ZP.li(couponselectpopupM_templateObject7(), RadioN/* RadioWrap */.M, function(param) {
    var isNone = param.isNone;
    return isNone ? (0,index_esm/* css */.iv)(couponselectpopupM_templateObject5(), RadioN/* RadioWrap */.M) : (0,index_esm/* css */.iv)(couponselectpopupM_templateObject6(), CouponInfo);
});
var CouponItem = index_esm/* default.label */.ZP.label(couponselectpopupM_templateObject8());
var CouponDownloadIcon = index_esm/* default.i */.ZP.i(couponselectpopupM_templateObject9(), (ico_spr_default()));
var CouponDownloadBtn = index_esm/* default.button */.ZP.button(_templateObject12(), function(param) {
    var soldOut = param.soldOut;
    return soldOut && (0,index_esm/* css */.iv)(couponselectpopupM_templateObject10());
}, function(param) {
    var downloaded = param.downloaded, soldOut = param.soldOut;
    return (downloaded || soldOut) && (0,index_esm/* css */.iv)(_templateObject11(), CouponDownloadIcon);
});
var CouponText = index_esm/* default.span */.ZP.span(_templateObject13());
var CouponNotice = index_esm/* default.p */.ZP.p(_templateObject14());
var CouponBadge = index_esm/* default.span */.ZP.span(_templateObject15());
var CouponTagGroup = index_esm/* default.span */.ZP.span(_templateObject16());
var CouponTag = index_esm/* default.span */.ZP.span(_templateObject19(), function(param) {
    var type = param.type;
    return type === "limited" && (0,index_esm/* css */.iv)(_templateObject17());
}, function(param) {
    var type = param.type;
    return type === "impending" && (0,index_esm/* css */.iv)(_templateObject18());
});
var CouponName = index_esm/* default.span */.ZP.span(_templateObject20());
var DiscountSummary = index_esm/* default.div */.ZP.div(_templateObject21());
var DiscountSummaryLabel = index_esm/* default.p */.ZP.p(_templateObject22());
var TooltipButton = index_esm/* default.button */.ZP.button(_templateObject23(), (ico_spr_default()));
var DiscountSummaryAmount = index_esm/* default.p */.ZP.p(_templateObject24());
var Tooltip = index_esm/* default.div */.ZP.div(_templateObject25());
var EmptyCouponbox = index_esm/* default.div */.ZP.div(_templateObject26());


// EXTERNAL MODULE: ./framework/ui/mobile/popup/PopupConfirm.tsx
var PopupConfirm = __webpack_require__(98513);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponByUser.ts
var useCouponByUser = __webpack_require__(70189);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/CouponPop.tsx



















/** 선착순 쿠폰 마감임박 잔여 수량 기준 */ var CouponPop_FCFS_IMMINENT_REMAIN_CNT = 20;
/** ```
 * 할인 전 총액
 * @param "item" 개별 쿠폰 데이터
 * @param "memberCount" 동행 여행자 수 adult: 어른, child: 아이, infant: 유아
 ``` */ var totalPrice = function(item, memberCount) {
    var adtPrice = Number(item.evAdtPrice); // 성인 총상품가
    var chdPrice = Number(item.evChdPrice); // 소아 총상품가
    var infPrice = Number(item.evInfPrice); // 유아 총상품가
    var adtPriceToT = adtPrice * memberCount.adult; // 성인 합산가
    var chdPriceToT = chdPrice * memberCount.child; // 소아 합산가
    var infPriceToT = infPrice * memberCount.infant; // 유아 합산가
    return adtPriceToT + chdPriceToT + infPriceToT; // 기본상품가 토탈 합산
};
/**
 *
 * @param _data 개별 쿠폰 데이터
 * @param memberCount 동행 여행자 수 adult: 어른, child: 아이, infant: 유아
 * @returns
 */ var discountPrice = function(_data, memberCount) {
    var totalDiscountPrice; // 할인 금액
    var discountInfo; // 성인할인가
    var adtCnt = memberCount.adult;
    var chdCnt = memberCount.child;
    var infCnt = memberCount.infant;
    if (_data.discDiviCd === "M") {
        // 정액
        totalDiscountPrice = _data.discAmt;
        discountInfo = "(정액할인)";
    } else {
        // 정율
        var adtPriceDiscount = Math.round(_data.evAdtPrice * _data.discRate / 100);
        var chdPriceDiscount = Math.round(_data.evChdPrice * _data.discRate / 100);
        var infPriceDiscount = Math.round(_data.evInfPrice * _data.discRate / 100);
        discountInfo = "(".concat(_data.discRate, "%할인)");
        totalDiscountPrice = adtPriceDiscount * adtCnt + chdPriceDiscount * chdCnt + infPriceDiscount * infCnt;
        if (_data.goodsPriceCd === "TOT" && _data.goodsPriceFr > totalPrice(_data, memberCount)) {
            totalDiscountPrice = 0;
        } else if (_data.goodsPriceCd === "PER") {
            _data.goodsPriceFr > _data.evAdtPrice && (adtPriceDiscount = 0);
            _data.goodsPriceFr > _data.evChdPrice && (chdPriceDiscount = 0);
            _data.goodsPriceFr > _data.evInfPrice && (infPriceDiscount = 0);
            totalDiscountPrice = adtPriceDiscount * adtCnt + chdPriceDiscount * chdCnt + infPriceDiscount * infCnt;
        }
    }
    return {
        totalPrice: totalDiscountPrice,
        label: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalDiscountPrice), "원").concat(discountInfo)
    };
};
/**
 *
 * @param coupon 선택된 쿠폰
 * @param loginInfo 로그인 정보
 * @param memberCount 동행 여행자 수 adult: 어른, child: 아이, infant: 유아
 * @returns
 */ var getFilteredCoupons = function(coupon, loginInfo, memberCount) {
    if (!coupon) return {
        availableCoupon: [],
        duplicateCoupon: []
    };
    var sysdate = dayjs_min_default()().format("YYYYMMDD");
    var memberGrade = loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.custGradeCd;
    var result = coupon.filter(function(item) {
        var remainingCouponCnt = item.issueCnt - item.issueCntTot;
        var isFcfsSoldOut = item.fcfsYn === "Y" && Number(item.remainCnt) <= 0;
        item.tourListNo = null;
        if (item.validityFrDt && item.validityToDt && !(item.validityFrDt <= sysdate && item.validityToDt >= sysdate)) return false;
        // 선착순 사용마감 쿠폰은 목록에 노출 (라디오 비활성)
        if (item.downYn === "Y" && remainingCouponCnt === 0 && item.couponDivi === "BA" && !isFcfsSoldOut) return false;
        if (item.couponDivi !== "BA" && item.downYn === "Y") return false;
        if (item.custGradeCd && memberGrade !== item.custGradeCd) return false;
        if (item.goodsPriceCd === "TOT" && item.goodsPriceFr >= totalPrice(item, memberCount)) return false;
        if (item.goodsPriceCd === "TOT" && item.goodsPriceTo > 0 && item.goodsPriceTo <= totalPrice(item, memberCount)) return false;
        if (item.goodsPriceCd === "PER" && item.goodsPriceFr >= item.evAdtPrice) return false;
        if (item.goodsPriceCd === "PER" && item.goodsPriceTo > 0 && item.goodsPriceTo <= item.evAdtPrice) return false;
        if (item.discDiviCd === "M" && !item.goodsPriceCd && item.discAmt > item.evAdtPrice) return false;
        item.calcObj = discountPrice(item, memberCount);
        if (item.discDiviCd !== "M" && !item.goodsPriceCd && item.calcObj.totalPrice > item.evAdtPrice) return false;
        return true;
    }).sort(function(a, b) {
        return b.calcObj.totalPrice - a.calcObj.totalPrice;
    });
    var availableCoupon = result.filter(function(v) {
        return v.multiUseYn !== "Y";
    }); // 일반
    var duplicateCoupon = result.filter(function(v) {
        return v.multiUseYn === "Y";
    }); // 중복
    return {
        availableCoupon: availableCoupon,
        duplicateCoupon: duplicateCoupon
    };
};
/**
 *
 * @param e 마우스 이벤트
 * @param coupon 선택된 쿠폰
 * @param webCustNo 고객번호
 * @param handleRefetch 에러 발생 시 refetch handler
 */ var handleDownload = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(e, coupon, webCustNo, handleRefetch) {
        var body, _tmp, result, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    body = (_tmp.compId = "1", _tmp.couponNo = coupon.couponNo, _tmp.webCustNo = webCustNo, _tmp);
                    return [
                        4,
                        (0,useCouponDown/* default */.Z)(body)
                    ];
                case 2:
                    result = _state.sent();
                    data = result.data;
                    if (data.errorCode === "0000") {
                        handleRefetch();
                    } else {
                        alert(data.errorMsg);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    alert("오류가 발생하였습니다.");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleDownload(e, coupon, webCustNo, handleRefetch) {
        return _ref.apply(this, arguments);
    };
}();

var CouponPop_CouponItem = function(param) {
    var coupon = param.coupon, webCustNo = param.webCustNo, evCd = param.evCd, index = param.index, handleRadio = param.handleRadio;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var couponType = coupon.multiUseYn === "Y" ? "duplicateCoupon" : "availableCoupon";
    var id = (0,react.useId)();
    var radioId = "".concat(couponType).concat(id).concat(index);
    var handleRefetch = function() {
        queryClient.refetchQueries({
            queryKey: [
                "useCouponByUser"
            ],
            type: "active"
        });
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("goods_down_coupon", {
        evCd: evCd,
        selectDiv: "availableCoupon"
    }).taggingClick;
    var isFcfs = coupon.fcfsYn === "Y";
    var remain = Number(coupon.remainCnt);
    var isSoldOut = isFcfs && remain <= 0;
    var isImpending = isFcfs && !isSoldOut && remain <= CouponPop_FCFS_IMMINENT_REMAIN_CNT;
    var needDownload = coupon.downYn === "Y" && coupon.couponDivi === "BA" && !isSoldOut;
    var isRadioDisabled = isSoldOut || coupon.downYn === "Y" && coupon.couponDivi === "BA";
    var discountBadge = coupon.discDiviCd === "M" ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(coupon.discAmt), "원") : "".concat(coupon.discRate, "%");
    var downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadBtn, {
        type: "button",
        downloaded: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "사용가능"
        })
    });
    if (isSoldOut) {
        downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadBtn, {
            type: "button",
            soldOut: true,
            disabled: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "마감"
            })
        });
    } else if (needDownload) {
        downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponDownloadBtn, {
            type: "button",
            onClick: function(e) {
                handleDownload(e, coupon, webCustNo, handleRefetch);
                taggingClick(coupon);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadIcon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "쿠폰받기"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponItem, {
            htmlFor: radioId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponInfo, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                            id: radioId,
                            name: couponType,
                            value: coupon.calcObj.totalPrice,
                            disabled: isRadioDisabled,
                            onChange: handleRadio,
                            "data-props": JSON.stringify(coupon)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponBadge, {
                                            children: [
                                                discountBadge,
                                                isFcfs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponTagGroup, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTag, {
                                                            type: "limited",
                                                            children: "선착순사용"
                                                        }),
                                                        isImpending && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTag, {
                                                            type: "impending",
                                                            children: "마감임박"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponName, {
                                            children: coupon.couponNm
                                        })
                                    ]
                                }),
                                isFcfs && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponNotice, {
                                    children: isSoldOut ? "선착순사용 가능 수량이 모두 소진되었습니다." : "예약완료 전 수량이 마감 될 수 있습니다."
                                })
                            ]
                        })
                    ]
                }),
                downloadButton
            ]
        })
    });
};
/**
 *
 * @param memberCount 동행 여행자 수 adult: 어른, child: 아이, infant: 유아
 * @returns
 */ var Component = function(param) {
    var evCd = param.evCd, memberCount = param.memberCount, callback = param.callback, _show = param.show, show = _show === void 0 ? true : _show, close = param.close;
    var ref, ref1;
    var loginResult = (0,useCustomerMe/* default */.ZP)();
    var loginInfo = (ref = loginResult.data) === null || ref === void 0 ? void 0 : ref.body;
    var webCustNo = loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.webCustNo;
    var couponFetch = (0,useCouponByUser/* default */.ZP)(evCd, webCustNo);
    var coupon = (ref1 = couponFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var availableRef = (0,react.useRef)(null);
    var duplicateRef = (0,react.useRef)(null);
    var summaryRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)({
        availableCoupon: 0,
        duplicateCoupon: 0
    }), discount = ref2[0], setDiscount = ref2[1];
    var ref3 = (0,react.useState)(false), tooltip = ref3[0], setTooltip = ref3[1];
    var ref4 = (0,react.useMemo)(function() {
        return getFilteredCoupons(coupon, loginInfo, memberCount);
    }, [
        coupon,
        loginInfo,
        memberCount
    ]), availableCoupon = ref4.availableCoupon, duplicateCoupon = ref4.duplicateCoupon;
    (0,react.useEffect)(function() {
        if (!tooltip) return;
        var handleClickOutside = function(e) {
            if (summaryRef.current && (0,_instanceof/* default */.Z)(e.target, Node) && !summaryRef.current.contains(e.target)) {
                setTooltip(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        tooltip
    ]);
    (0,react.useEffect)(function() {
        if (!((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.nonUser) === false)) close === null || close === void 0 ? void 0 : close();
    }, [
        loginInfo
    ]);
    var handleRadio = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setDiscount((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discount), (0,_define_property/* default */.Z)({}, name, value)));
    };
    var couponDataSet = function() {
        var ref, ref1;
        var couponData = [];
        var _available = (ref = availableRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("input:checked");
        var _duplicate = (ref1 = duplicateRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector("input:checked");
        if (_available && _available.getAttribute("data-props") !== "false") {
            couponData.push(JSON.parse(_available.getAttribute("data-props")));
        }
        if (_duplicate && _duplicate.getAttribute("data-props") !== "false") {
            couponData.push(JSON.parse(_duplicate.getAttribute("data-props")));
        }
        return couponData;
    };
    var handleSubmit = function() {
        var couponData = couponDataSet();
        typeof callback === "function" && callback(couponData);
        close === null || close === void 0 ? void 0 : close();
    };
    var handleClose = function() {
        close === null || close === void 0 ? void 0 : close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupConfirm/* default */.ZP, {
        open: !!show,
        title: "할인 쿠폰 선택",
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSelectContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponSectionTitle, {
                                children: "할인쿠폰"
                            }),
                            availableCoupon.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponList, {
                                ref: availableRef,
                                children: [
                                    availableCoupon.map(function(coup, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponPop_CouponItem, {
                                            coupon: coup,
                                            evCd: evCd,
                                            index: index,
                                            handleRadio: handleRadio,
                                            webCustNo: webCustNo
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
                                        isNone: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                                            id: "availableCouponNot",
                                            name: "availableCoupon",
                                            value: 0,
                                            onChange: handleRadio,
                                            defaultChecked: true,
                                            "data-props": "false",
                                            children: "쿠폰 사용 안함"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCouponbox, {
                                children: "사용가능한 쿠폰이 없습니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponSectionTitle, {
                                children: "중복 할인 쿠폰"
                            }),
                            duplicateCoupon.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponList, {
                                ref: duplicateRef,
                                children: [
                                    duplicateCoupon.map(function(coup, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponPop_CouponItem, {
                                            coupon: coup,
                                            evCd: evCd,
                                            index: index,
                                            handleRadio: handleRadio,
                                            webCustNo: webCustNo
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
                                        isNone: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                                            id: "duplicateCouponNot",
                                            name: "duplicateCoupon",
                                            value: 0,
                                            onChange: handleRadio,
                                            defaultChecked: true,
                                            "data-props": "false",
                                            children: "쿠폰 사용 안함"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCouponbox, {
                                children: "사용가능한 쿠폰이 없습니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummary, {
                        children: [
                            tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                                ref: summaryRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰은 노랑풍선 회원만 사용 가능합니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰에 따라 사용 조건이 상이할 수 있으므로 상세 조건을 확인해주세요."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰 할인 금액은 최종 결제금액에 따라 변동 될 수 있습니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                "예약 완료 후 적용된 쿠폰은 변경 불가하며, 쿠폰 변경을 원할 경우",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "예약 취소 후 다시 예약해주세요."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "예약 후 인원 취소 및 변경 진행 시, 적용된 쿠폰은 자동 취소 됩니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "예약 취소 시 사용된 쿠폰은 복구가 불가합니다."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummaryLabel, {
                                children: [
                                    "할인 금액",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipButton, {
                                        type: "button",
                                        onClick: function() {
                                            return setTooltip(!tooltip);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummaryAmount, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                        children: [
                                            "-",
                                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(Number(discount.availableCoupon) + Number(discount.duplicateCoupon))
                                        ]
                                    }),
                                    " 원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupConfirm/* PopupButtonWrap */.EN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* PopupButton */.cy, {
                        types: "cancle",
                        onClick: handleClose,
                        children: "취소"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* PopupButton */.cy, {
                        types: "submit",
                        onClick: handleSubmit,
                        children: "선택완료"
                    })
                ]
            })
        ]
    });
};
var CouponPop = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var mobile_CouponPop = (/*#__PURE__*/(0,react.memo)(CouponPop));

// EXTERNAL MODULE: ./components/product/common/popup/mobile/EventListPopup/index.tsx + 9 modules
var EventListPopup = __webpack_require__(62306);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./framework/ui/mobile/popup/index.ts + 3 modules
var popup = __webpack_require__(62835);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventDetail.ts
var useEventDetail = __webpack_require__(7682);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailSNB/InquiryPopup.tsx










var InquiryPopup = function(props) {
    var evCd = props.evCd, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "evCd"
    ]);
    /** 행사 정보 */ var event = (0,useEventDetail/* default */.ZP)(evCd).data.body;
    var _mgmUserTelNo;
    var telNo = event.mgmUserInfo === "Y" ? event.phoneDirect : (_mgmUserTelNo = event.mgmUserTelNo) !== null && _mgmUserTelNo !== void 0 ? _mgmUserTelNo : event.phoneDirect;
    var inquiry = function() {
        var path = "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/qnaWrite.yb?evCd=").concat(evCd);
        (0,commonUtil/* hrefSSO */.VQ)(path);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        size: "basic",
        title: "문의하기",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
            direction: "column",
            gap: "10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                    size: "default",
                    types: "base",
                    text: "1:1 문의",
                    onClick: inquiry
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                    size: "default",
                    types: "base",
                    text: "전화 문의",
                    onClick: function() {
                        location.href = "tel:".concat(telNo);
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var detailSNB_InquiryPopup = (InquiryPopup);

// EXTERNAL MODULE: ./public/M/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(35308);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventAvailability.ts
var useEventAvailability = __webpack_require__(69230);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailSNB/index.tsx






function detailSNB_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n"
    ]);
    detailSNB_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function detailSNB_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	z-index: 6;\n	display: flex;\n	flex: 1 1 100%;\n	width: 100%;\n	position: fixed;\n	left: 0;\n	right: 0;\n	bottom: 0;\n	button[type="button"] {\n		padding: 4px 16px;\n		&:disabled {\n			background-color: var(--disable-line-color);\n		}\n	}\n'
    ]);
    detailSNB_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function detailSNB_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-width: 20%;\n	height: 56px;\n	border-radius: 0;\n	background-color: #fff9e8;\n	color: var(--title-color);\n	font-size: var(--regular-size);\n\n	+ button {\n		margin-left: 0;\n	}\n"
    ]);
    detailSNB_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function detailSNB_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-width: 30%;\n	height: 56px;\n	border-radius: 0;\n	background-color: var(--title-color);\n	font-size: var(--regular-size);\n	color: #fff;\n	+ button {\n		margin-left: 0;\n	}\n"
    ]);
    detailSNB_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function detailSNB_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	min-width: 50%;\n	height: 56px;\n	border-radius: 0 !important;\n	background-color: var(--brand-color);\n	font-family: "PT-bold";\n	font-size: 20px;\n	/* color: ',
        "; */\n	color: var(--title-color);\n\n	",
        "\n"
    ]);
    detailSNB_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function detailSNB_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	bottom: -20px;\n	z-index: 101;\n	width: 100%;\n	padding: 36px 0 0;\n	border-top-left-radius: 15px;\n	border-top-right-radius: 15px;\n	background: #fff;\n	box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);\n"
    ]);
    detailSNB_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function detailSNB_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	bottom: 55px;\n	left: 0;\n	right: 0;\n	box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);\n"
    ]);
    detailSNB_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function detailSNB_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	/* margin: 10px 0; */\n	padding: 0 20px;\n\n	@media (orientation: landscape) {\n		max-height: 50px;\n		overflow-y: scroll;\n	}\n"
    ]);
    detailSNB_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function detailSNB_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	gap: 15px;\n	+ li {\n		padding-top: 16px;\n	}\n	> div {\n		p {\n			line-height: 1;\n			margin-bottom: 4px;\n			font-family: "PT-medium";\n			font-size: var(--basic-size);\n			color: var(--sub-title-color);\n		}\n	}\n'
    ]);
    detailSNB_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function detailSNB_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	width: 100%;\n	line-height: 1;\n	text-align: right;\n	font-size: var(--regular-size);\n	font-family: "PT-semibold";\n	color: var(--title-color);\n	> em {\n		font-family: "PT-bold";\n	}\n'
    ]);
    detailSNB_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function detailSNB_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 50px;\n	padding: 0 20px;\n\n	img {\n		width: 100%;\n		height: 100%;\n	}\n	+ h4 {\n		margin-top: 16px;\n	}\n"
    ]);
    detailSNB_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function detailSNB_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	line-height: 1.5;\n	padding: 0 0 16px;\n	margin: 0 20px 16px;\n	border-bottom: 1px solid var(--hr-color);\n	font-size: var(--regular-size);\n	font-family: "PT-semibold";\n	color: var(--title-color);\n'
    ]);
    detailSNB_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function detailSNB_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	height: 56px;\n	margin-top: 24px;\n	padding: 8px 20px;\n	background-color: var(--label-bg-color);\n\n	button {\n		display: flex;\n		justify-content: center;\n		align-items: center;\n		gap: 6px;\n		height: 24px;\n		padding: 2px 8px;\n		border-radius: 8px;\n		border: 1px solid var(--brand-deep-color);\n		background: #fff9e8;\n		font-size: var(--small-size);\n		font-family: "PT-bold";\n		color: var(--brand-deep-color);\n		white-space: nowrap;\n\n		&::before {\n			display: flex;\n			width: 16px;\n			height: 16px;\n			background: url(',
        ') no-repeat 0 -560px;\n			content: "";\n		}\n	}\n\n	> span {\n		line-height: 1.5;\n		font-family: "PT-medium";\n		font-size: 16px;\n		color: var(--primary-color);\n		> em {\n			font-family: "PT-bold";\n			font-size: 26px;\n		}\n	}\n\n	',
        " {\n		color: ",
        ";\n	}\n"
    ]);
    detailSNB_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function detailSNB_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 50%;\n	z-index: 6;\n	width: 100%;\n	height: 36px;\n	background: transparent;\n	border-bottom: 0;\n	transform: translateX(-50%);\n\n	&::before {\n		position: absolute;\n		top: 17px;\n		left: 50%;\n		display: flex;\n		width: 18px;\n		height: 8px;\n		background: url(",
        ') no-repeat -16px -560px;\n		transform: translateX(calc(-50% 0));\n		content: "";\n	}\n'
    ]);
    detailSNB_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}























var detailSNB_Wrap = index_esm/* default.div */.ZP.div(detailSNB_templateObject());
var FixedBtnBlock = index_esm/* default.div */.ZP.div(detailSNB_templateObject1());
var InquiryButton = (0,index_esm/* default */.ZP)(mobile_button/* TextDefaultButton */.mm)(detailSNB_templateObject2());
var ChangeDepartureButton = (0,index_esm/* default */.ZP)(mobile_button/* TextDefaultButton */.mm)(detailSNB_templateObject3());
var ReserveButton = (0,index_esm/* default */.ZP)(mobile_button/* TextDefaultButton */.mm)(detailSNB_templateObject4(), function(param) {
    var waiting = param.waiting;
    return waiting ? "#fff" : "var(--title-color)";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "\n		background-color: var(--disable-text-color);\n		color: #fff;\n		cursor: unset;" : "";
});
var LayerWrap = index_esm/* default.div */.ZP.div(detailSNB_templateObject5());
var PartnerLayerWrap = (0,index_esm/* default */.ZP)(LayerWrap)(detailSNB_templateObject6());
var InfoList = index_esm/* default.ul */.ZP.ul(detailSNB_templateObject7());
var InfoListItem = index_esm/* default.li */.ZP.li(detailSNB_templateObject8());
var ItemPrice = index_esm/* default.span */.ZP.span(detailSNB_templateObject9());
var ImgWrap = index_esm/* default.div */.ZP.div(detailSNB_templateObject10());
var DayTitle = index_esm/* default.h4 */.ZP.h4(detailSNB_templateObject11());
var TotalWrap = index_esm/* default.div */.ZP.div(detailSNB_templateObject12(), (ico_spr_default()), ItemPrice, function(param) {
    var disabled = param.disabled;
    return disabled ? "var(--disable-text-color)" : "var(--primary-color)";
});
var LayerCloseButton = index_esm/* default.button */.ZP.button(detailSNB_templateObject13(), (ico_spr_default()));
var detailSNB_daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var DetailSNBComponent = function(props) {
    var ref, ref1, ref2;
    var maxCount = 30;
    var event = props.eventDetail;
    var ref3 = (0,react.useState)(false), show = ref3[0], setShow = ref3[1];
    // 패밀리 상품(familyYn === "Y")은 성인 2, 아동 2, 유아 0으로 기본 세팅
    var ref4 = (0,react.useState)(event.familyYn === "Y" ? 2 : 1), adult = ref4[0], setAdult = ref4[1];
    var ref5 = (0,react.useState)(event.familyYn === "Y" ? 2 : 0), child = ref5[0], setChild = ref5[1];
    var ref6 = (0,react.useState)(0), infant = ref6[0], setInfant = ref6[1];
    var ref7 = (0,react.useState)([]), coupon = ref7[0], setCoupon = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref8[0];
    var evStartDt = event.evStartDt, evCd = event.evCd, goodsTp = event.goodsTp, goodsCd = event.goodsCd;
    var startDtDayjs = dayjs_min_default()(evStartDt);
    var startFormat = "".concat(startDtDayjs.format("YYYY년 MM월 DD일"), " (").concat(detailSNB_daykor[startDtDayjs.day()], "요일 출발)");
    /** 로그인 정보 */ var useSign = (0,useCustomerMe/* default */.ZP)();
    var isSignin = ((ref = useSign.data) === null || ref === void 0 ? void 0 : ref.body.nonUser) === false;
    /** 배너 */ var useBnrContents = (0,useBannerContents/* default */.ZP)("GORV"); // WEB_CONT_DIVI_CD 상품상세_요금영역
    var bannerList = ((ref1 = useBnrContents.data) === null || ref1 === void 0 ? void 0 : ref1.body) || [];
    /** 금액 */ var useEvtPrice = (0,useEventPrice/* default */.ZP)(evCd);
    var price = (0,eventUtil/* getPrice */.aS)((ref2 = useEvtPrice.data) === null || ref2 === void 0 ? void 0 : ref2.body);
    /** 쿠폰 할인금액 */ var discount = (0,react.useMemo)(function() {
        return coupon.reduce(function(acc, cur) {
            return acc + cur.calcObj.totalPrice;
        }, 0);
    }, [
        coupon
    ]);
    /** 총 금액 */ var totalPrice = (0,react.useMemo)(function() {
        if (!price) return 0;
        return price.adult * adult + price.child * child + price.infant * infant - discount;
    }, [
        adult,
        child,
        infant,
        price,
        discount
    ]);
    /** 쿠폰 초기화 */ var resetCoupon = function() {
        if (discount > 0) {
            MessageUtil.alert("쿠폰을 재적용 해주세요.");
            setCoupon([]);
        }
    };
    /** 쿠폰 팝업 */ var openCoupon = function() {
        var callbackCoupon = function(prop) {
            setCoupon(prop);
        };
        if (isSignin) {
            var member = {
                adult: adult,
                child: child,
                infant: infant
            };
            open(function(overlay) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_CouponPop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                    evCd: evCd,
                    memberCount: member,
                    callback: callbackCoupon
                }));
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    afterConfirm: function() {
                        return LoginUtil.login();
                    }
                }));
            });
        }
    };
    /** 예약하기 버튼 */ var reserveText = (0,eventUtil/* reserveButtonText */._f)(props.eventDetail);
    var handleReserve = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, msg, isValidFamily, ref1, eventAvailability, adtCnt, chdCnt, infCnt, ref2, menu, couponParams, nextUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!show) {
                            msg = "";
                            if (reserveText[1] === "예약마감") {
                                msg = "예약이 마감되었습니다.<br/>출발일 변경에서 예약가능 상품으로<br/>예약하시거나, 담당자에게 문의 해주세요.";
                            } else if (reserveText[1] === "출발완료") {
                                msg = "이미 출발한 상품입니다.<br/>출발일 변경에서 예약가능 상품으로<br/>예약하시거나, 담당자에게 문의 해주세요.";
                            }
                            if (msg) {
                                MessageUtil.alert(msg);
                                return [
                                    2
                                ];
                            }
                            setShow(true);
                            return [
                                2
                            ];
                        }
                        // 패밀리 상품은 (성인2 + 아동2)의 배수여야 예약 가능 (유아는 조건에 영향 없음)
                        if (event.familyYn === "Y") {
                            isValidFamily = adult === child && adult > 0 && adult % 2 === 0;
                            if (!isValidFamily) {
                                MessageUtil.alert("패밀리팩 상품입니다.<br/>성인과 아동 인원을 동일하게 선택해 주세요.<br/>(예: 성인 2명 + 아동 2명)");
                                return [
                                    2
                                ];
                            }
                        }
                        if (!(event.fixRervCd === "YT")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,useEventAvailability/* eventAvailabilityAsync */.$o)(evCd)
                        ];
                    case 1:
                        eventAvailability = _state.sent();
                        if (((ref1 = eventAvailability.data) === null || ref1 === void 0 ? void 0 : ref1.body) < adult + child + infant) {
                            MessageUtil.alert("예약 가능 인원을 초과하였습니다.<br/>담당자에게 문의해 주세요.");
                            setShow(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        adtCnt = adult > 1 ? "".concat(adult) : "1";
                        chdCnt = child > 0 ? "".concat(child) : "0";
                        infCnt = infant > 0 ? "".concat(infant) : "0";
                        menu = (ref2 = (ref = (0,commonUtil/* getQueryParams */.vl)(location.search)) === null || ref === void 0 ? void 0 : ref.menu) !== null && ref2 !== void 0 ? ref2 : "";
                        couponParams = coupon.map(function(v) {
                            return v.couponNo;
                        }).join(",");
                        nextUrl = "".concat(config_public/* default.ENV_TRAVEL_URL */.Z.ENV_TRAVEL_URL, "/pkg/reserve?evCd=").concat(evCd, "&adtCnt=").concat(adtCnt, "&chdCnt=").concat(chdCnt, "&infCnt=").concat(infCnt, "&menu=").concat(menu).concat(couponParams ? "&coupon=".concat(couponParams) : "");
                        /* 로그인 안되어있으면 로그인페이지 이동 */ if (!isSignin) {
                            LoginUtil.loginRsvn(nextUrl);
                            return [
                                2
                            ];
                        }
                        (0,commonUtil/* hrefSSO */.VQ)(nextUrl);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReserve() {
            return _ref.apply(this, arguments);
        };
    }();
    var changeDepartureDay = function() {
        open(function(popupProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popupProps), {
                goodsCd: goodsCd,
                startMonth: evStartDt
            }));
        });
    };
    /** 문의하기 */ var hanldeQna = function() {
        open(function(overlay) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailSNB_InquiryPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                evCd: evCd
            }));
        });
    };
    // tagging 출발일 보기
    var ref9 = (0,useTagging/* useTaggingClick */.b)("pkg_select_dtl_change", event), taggingClickChange = ref9.taggingClick;
    // tagging 예약하기
    var ref10 = (0,useTagging/* useTaggingClick */.b)("pkg_select_evCd_pkgDtl", {
        eventDetail: event,
        count: {
            adultCnt: adult,
            childCnt: child,
            infantCnt: infant
        },
        coupon: coupon
    }), taggingClickReserve = ref10.taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailSNB_Wrap, {
        children: [
            show && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PartnerLayerWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayerCloseButton, {
                        onClick: function() {
                            return setShow(false);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "닫기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {})
                        ]
                    }),
                    bannerList.map(function(param, index) {
                        var mLink = param.mLink, mTarget = param.mTarget, mAlt = param.mAlt, mImgPath = param.mImgPath;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL).concat(mLink),
                                target: (0,commonUtil/* getTarget */.U9)(mTarget),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: mImgPath ? "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(mImgPath) : (ico_nodata_default()),
                                    alt: mAlt
                                })
                            }, index)
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DayTitle, {
                        children: startFormat
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "성인"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price.adult)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* CountingButton */.OM, {
                                        minValue: 1,
                                        increase: function(count) {
                                            setAdult(count);
                                            resetCoupon();
                                        },
                                        decrease: function(count) {
                                            if (count > maxCount) return;
                                            setAdult(count);
                                            resetCoupon();
                                        },
                                        value: adult
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "아동"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(goodsTp) && (price === null || price === void 0 ? void 0 : price.child) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price.child)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* CountingButton */.OM, {
                                        increase: function(count) {
                                            setChild(count);
                                            resetCoupon();
                                        },
                                        decrease: function(count) {
                                            setChild(count);
                                            resetCoupon();
                                        },
                                        value: child
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "유아"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(goodsTp) && (price === null || price === void 0 ? void 0 : price.infant) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price.infant)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* CountingButton */.OM, {
                                        increase: function(count) {
                                            setInfant(count);
                                            resetCoupon();
                                        },
                                        decrease: function(count) {
                                            setInfant(count);
                                            resetCoupon();
                                        },
                                        value: infant
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: openCoupon,
                                children: "쿠폰 적용"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPrice)
                                    }),
                                    " 원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FixedBtnBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InquiryButton, {
                        text: "문의",
                        onClick: hanldeQna
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeDepartureButton, {
                        types: "confirm",
                        text: "출발일 변경",
                        onClick: function() {
                            changeDepartureDay();
                            taggingClickChange();
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReserveButton, {
                        types: reserveText[0],
                        text: reserveText[1],
                        isDisabled: reserveText[0] === "disabled",
                        waiting: reserveText[1] === "대기예약",
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        taggingClickReserve();
                                        return [
                                            4,
                                            handleReserve()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    })
                ]
            })
        ]
    });
};
var DetailSNB = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailSNB Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSNBComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailSNB = (/*#__PURE__*/(0,react.memo)(DetailSNB));

// EXTERNAL MODULE: ./components/product/pages/detailPackage/mobile/detailSchedule/index.tsx + 3 modules
var detailSchedule = __webpack_require__(9432);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/mobile/detailScheduleSummary/index.tsx + 1 modules
var detailScheduleSummary = __webpack_require__(15981);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts
var useConfigureAxios = __webpack_require__(83839);
;// CONCATENATED MODULE: ./pages/product/detailPackage.m.page.tsx






/** 컴포넌트 */ 




















/* 최근 본 상품 저장 **/ var detailPackage_m_page_daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var Page = function(props) {
    var ref, ref1;
    /** 예외처리 */ (0,react.useEffect)(function() {
        if (props.message) {
            alert(props.message);
            location.href = "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL);
        }
    }, []);
    if (props.message) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    /** 정상 */ var _query = props.query, evCd = _query.evCd, goodsCd = _query.goodsCd, dspSid = _query.dspSid, menu = _query.menu, eventDetail = props.eventDetail, goodsImage = props.goodsImage;
    var router = (0,next_router.useRouter)();
    var mmdd = evCd.split("-")[1].substring(2, 6);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 100);
    }, [
        router
    ]);
    /** 로그인 정보 */ var signin = (0,useCustomerMe/* default */.ZP)();
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.webCustNo) || "";
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /** 최근 본 상품 SET */ var setRecently = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(eventDetail, goodsImage) {
            var webCustId, ref, userId, evCd, evStartDt, outDeprtTm, evArriveDt, inArrvTm, trCompanySnm, trCompanyNm, trTp, pathname, queries, search, detailedUrl, imgUrl, _evCd, goodsId, _evNm, goodsName, type, viewDate, category, soldoutYn, trafficCode, _tmp, dayOfWeekStart, dayOfWeekArrive, outDeprtTime, inArrvTime, information, result, _tmp1, _tmp2, e;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        webCustId = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                        userId = (0,commonUtil/* getCookie */.ej)("userId");
                        if (!userId) return [
                            2
                        ];
                        evCd = eventDetail.evCd, evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, evArriveDt = eventDetail.evArriveDt, inArrvTm = eventDetail.inArrvTm, trCompanySnm = eventDetail.trCompanySnm, trCompanyNm = eventDetail.trCompanyNm, trTp = eventDetail.trTp;
                        pathname = location.pathname;
                        queries = (0,commonUtil/* getQueryParams */.vl)();
                        search = "?menu=".concat(queries.menu, "&dspSid=").concat(queries.dspSid, "&evCd=").concat(evCd);
                        detailedUrl = "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL).concat(pathname.replace(/\.m/i, "")).concat(search);
                        imgUrl = ((ref = goodsImage[0]) === null || ref === void 0 ? void 0 : ref.imageThum3) || "";
                        goodsId = (_evCd = eventDetail.evCd) !== null && _evCd !== void 0 ? _evCd : "";
                        goodsName = (_evNm = eventDetail.evNm) !== null && _evNm !== void 0 ? _evNm : "";
                        type = eventDetail.goodsTp === "D" ? "DMT" : "PKG";
                        viewDate = dayjs_min_default()().format("YYYY.MM.DD HH:mm:ss");
                        category = (0,goodsUtil/* goodsTpLabel */.mk)(eventDetail.goodsTp).join(";");
                        soldoutYn = "";
                        _tmp = {};
                        trafficCode = (_tmp.A = trCompanySnm, _tmp.T = "TRAIN", _tmp.S = "SHIP", _tmp.B = "BUS", _tmp)[trTp] || "ETC";
                        dayOfWeekStart = detailPackage_m_page_daykor[dayjs_min_default()(evStartDt).day()];
                        dayOfWeekArrive = detailPackage_m_page_daykor[dayjs_min_default()(evArriveDt).day()];
                        outDeprtTime = outDeprtTm ? "".concat(outDeprtTm.slice(0, 2), ":").concat(outDeprtTm.slice(2)) : "";
                        inArrvTime = inArrvTm ? "".concat(inArrvTm.slice(0, 2), ":").concat(inArrvTm.slice(2)) : "";
                        information = "".concat(dayjs_min_default()(evStartDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekStart, ");").concat(outDeprtTime, ";") + "".concat(dayjs_min_default()(evArriveDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekArrive, ");").concat(inArrvTime, ";") + "".concat(trafficCode, ";").concat(trTp ? trCompanyNm : "교통불포함");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp1 = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp1.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/user/recentlyViewed"), _tmp1.method = "POST", _tmp1.data = {
                                imgUrl: imgUrl,
                                goodsId: goodsId,
                                goodsName: goodsName,
                                information: information,
                                type: type,
                                viewDate: viewDate,
                                userId: userId,
                                detailedUrl: detailedUrl,
                                webCustId: webCustId,
                                category: category,
                                soldoutYn: soldoutYn
                            }, _tmp1))
                        ];
                    case 2:
                        result = _state.sent();
                        _tmp2 = {};
                        if (result.data.code === "0000") queryClient.refetchQueries((_tmp2.queryKey = [
                            "useGetRecently"
                        ], _tmp2.type = "active", _tmp2));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function setRecently(eventDetail, goodsImage) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!signin.isFetching) {
            setRecently(eventDetail, goodsImage, webCustNo);
        }
    }, [
        signin
    ]);
    // tagging load
    (0,useTagging/* useTaggingLoad */.q)("pkg_view_dtl", eventDetail);
    // tagging 찜하기
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_evCd_wish", eventDetail).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Mobile/* default */.Z, {
                notFixed: true,
                title: "".concat(mmdd.substring(0, 2), "월 ").concat(mmdd.substring(2, 4), "일 출발"),
                tools: [
                    "wish",
                    "share"
                ],
                pageProps: {
                    evCd: evCd,
                    goodsCd: goodsCd,
                    dspSid: dspSid,
                    menu: menu
                },
                wishAddConfirm: function() {
                    return taggingClick({
                        wishYn: "Y"
                    });
                },
                wishRemoveConfirm: function() {
                    return taggingClick({
                        wishYn: "N"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailScheduleSummary/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailBanner, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailPrice/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailCoupon, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailSchedule/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailPromotion, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailRecommendProduct, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailSNB, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMTags/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var detailPackage_m_page = (Page);


/***/ }),

/***/ 33954:
/***/ (function(module) {

module.exports = "/_next/static/images/banner_yellowpick_571.9xgQ2TYb.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7700,2335,8866,1712,1863,431,788,8235,764,6322,9272,8484,3432,9939,9774,2888,179], function() { return __webpack_exec__(49771); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);